import React from "react";
import classNames from "classnames";
import { Trans } from "react-i18next";

export const HolidayStatus = ({ approved }) => (
  <div
    className={classNames("px-2 py-1 rounded d-inline-block status", {
      "null": approved === null,
      "approved": approved === true,
      "rejected": approved === false,
    })}
  >
    {approved === null && <Trans>Requested</Trans>}
    {approved === true && <Trans>Approved</Trans>}
    {approved === false && <Trans>Rejected</Trans>}
  </div>
);

export default HolidayStatus;
